<ion-card>
  <div class="total">
    <smr-sale-total-summary [sale]="sale"> </smr-sale-total-summary>
  </div>

  <div class="tip" *ngIf="sale.tips.count() > 0">
    <ion-list>
      <ion-item
      *ngFor="let tip of sale.tips; let tipIndex = index"
      lines="none"
      (click)="editTip(tip, tipIndex)"
      [ngClass]="{ 'sm-error': tip.isRefunded }"
      >
        {{ tip.stylist.firstName }}
        {{ tip.stylist.lastName ? tip.stylist.lastName.charAt(0) : "" }}
        <div slot="end">{{ tip.isRefunded ? '-' : ''}}{{ tip.value | salonMonsterCurrency }}</div>
      </ion-item>
    </ion-list>
  </div>
  <div class="payment" *ngIf="sale.payments.count() > 0">
    <ion-list *ngIf="sale.payments.count() > 0">
      <ion-item
        *ngFor="let payment of sale.payments; let paymentIndex = index"
        lines="none"
        class="sm-payment-button"
        (click)="editPayment(payment, paymentIndex)"
      >
        {{ payment.name }}
        <div slot="end">{{ payment.amount | salonMonsterCurrency }}</div>
      </ion-item>
    </ion-list>
  </div>
  <div class="balance" *ngIf="sale.payments.count() > 0">
    <ion-list>
        <ion-item lines="none" *ngIf="!cashTip"><b class="sm-sale-total">Balance:</b><div slot="end"> <b>{{ sale.balance | salonMonsterCurrency }}</b></div></ion-item>
        <ion-item lines="none" *ngIf="cashTip"><b class="sm-sale-total">Change due:</b><div slot="end"> <b>{{ 0 - sale.balance | salonMonsterCurrency }}</b></div></ion-item>
    </ion-list>
  </div>

  <smr-sale-checkout-buttons
    *ngIf="showButtons"
    (saleUpdated)="onSaleUpdated($event)"
    [sale]="sale"
    [cashTip]="cashTip"
    [isFromBookings]="isFromBookings"
    [isFromRegisterClosure]="isFromRegisterClosure">
  </smr-sale-checkout-buttons>

</ion-card>
